<template>
  <div>
    <div class="container">
      <div class="columns">
        <div class="column">
          <div class="box">
            <h2 class="subtitle is-pulled-left">My Resources</h2>
            <!-- table of courses -->
            <table class="table is-fullwidth is-bordered is-striped">
              <thead>
                <tr>
                  <th>
                    Folders
                    <button
                      class="button collapse-all is-pulled-right"
                      @click="collapseAll"
                    >Collapse All</button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="course in courses" :key="course.id">
                  <td>
                    <!-- button to open a course folder -->
                    <a @click="toggleCourseFolder(course.id)">
                      <span class="icon">
                        <font-awesome-icon class="folder" :icon="courseFolderIcon(course.id)" />
                      </span>
                      {{course.name}}
                    </a>
                    <!-- table of modules within a course -->
                    <table
                      class="table is-fullwidth is-striped"
                      v-show="activeCourses.includes(course.id)"
                    >
                      <tbody>
                        <tr v-for="module in course.modules" :key="module.id">
                          <td v-if="moduleHasFiles(module)">
                            <!-- button to open a module -->
                            <a @click="toggleModuleFolder(module.id)">
                              <span class="icon">
                                <font-awesome-icon
                                  class="folder"
                                  :icon="moduleFolderIcon(module.id)"
                                />
                              </span>
                              {{module.name}}
                            </a>
                            <!-- table of lessons within a module -->
                            <table
                              class="table is-fullwidth is-striped"
                              v-show="activeModules.includes(module.id)"
                            >
                              <tbody>
                                <tr v-for="lesson in module.lessons" :key="lesson.id">
                                  <td v-if="hasFiles(lesson)">
                                    <!-- button to open a lesson -->
                                    <a @click="toggleLessonFolder(lesson.id)">
                                      <span class="icon">
                                        <font-awesome-icon
                                          class="folder"
                                          :icon="lessonFolderIcon(lesson.id)"
                                        />
                                      </span>
                                      {{lesson.name}}
                                    </a>
                                    <!-- table of files within the lesson -->
                                    <table
                                      class="table is-fullwidth is-striped is-hoverable"
                                      v-show="activeLessons.includes(lesson.id)"
                                    >
                                      <thead>
                                        <tr>
                                          <th>Filename</th>
                                          <th>Type</th>
                                          <th>Size</th>
                                          <th>Date Modified</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="file in lesson.attachments" :key="file.id">
                                          <td>
                                            <!-- the actual file link -->
                                            <a target="_blank" :href="file.url">
                                              <span class="icon">
                                                <font-awesome-icon
                                                  class="folder"
                                                  :icon="fileIcon(file.extension)"
                                                />
                                              </span>
                                              {{file.filename}}
                                            </a>
                                          </td>
                                          <td>{{file.extension}}</td>
                                          <td>{{fileSize(file.size)}}</td>
                                          <td>{{file.updated_at}}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CourseClient } from "@/clients/CourseClient.js";
import fileBrowser from "@/components/files/Browser.vue";
export default {
  name: "Resources",
  components: { fileBrowser },
  data() {
    return {
      courses: Array,
      activeCourses: [],
      activeModules: [],
      activeLessons: []
    };
  },
  methods: {
    moduleHasFiles(unit) {
      var result = false;
      for (var lesson of unit.lessons) {
        if (this.hasFiles(lesson)) {
          result = true;
        }
      }
      return result;
    },
    hasFiles(lesson) {
      if (lesson.attachments.length < 1) {
        return false;
      } else {
        return true;
      }
    },
    collapseAll() {
      this.activeCourses = [];
      this.activeModules = [];
      this.activeLessons = [];
    },
    fileIcon(fileType) {
      switch (fileType) {
        case "pdf":
          return "file-pdf";
        case "doc":
          return "file-word";
        case "docx":
          return "file-word";
        case "txt":
          return "file-word";
        case "csv":
          return "file-csv";
        case "jpeg":
          return "file-image";
        case "jpg":
          return "file-image";
        case "png":
          return "file-image";
        case "svg":
          return "file-image";
        case "zip":
          return "file-archive";
        case "mp3":
          return "file-audio";
        case "mp4":
          return "file-video";
        default:
          return "file";
      }
    },
    courseFolderIcon(courseId) {
      if (this.activeCourses.includes(courseId)) {
        return "folder-open";
      } else {
        return "folder";
      }
    },
    moduleFolderIcon(moduleId) {
      if (this.activeModules.includes(moduleId)) {
        return "folder-open";
      } else {
        return "folder";
      }
    },
    lessonFolderIcon(lessonId) {
      if (this.activeLessons.includes(lessonId)) {
        return "folder-open";
      } else {
        return "folder";
      }
    },
    fileSize(rawSize) {
      //converts size from bytes to human readable

      return Math.round(((rawSize / 1024) * 10) / 10) + "kb";
    },
    toggleLessonFolder(lessonId) {
      if (this.activeLessons.includes(lessonId)) {
        this.removeAllElements(this.activeLessons, lessonId);
      } else {
        this.activeLessons.push(lessonId);
      }
    },
    toggleModuleFolder(moduleId) {
      if (this.activeModules.includes(moduleId)) {
        this.removeAllElements(this.activeModules, moduleId);
      } else {
        this.activeModules.push(moduleId);
      }
    },
    toggleCourseFolder(courseId) {
      if (this.activeCourses.includes(courseId)) {
        this.removeAllElements(this.activeCourses, courseId);
      } else {
        this.activeCourses.push(courseId);
      }
    },
    removeAllElements(array, elem) {
      var index = array.indexOf(elem);
      while (index > -1) {
        array.splice(index, 1);
        index = array.indexOf(elem);
      }
    }
  },
  mounted() {
    this.$store.dispatch("loader/show", "Loading your resources");

    CourseClient.getCourses()
      .then(response => {
        this.courses = response.data.courses;
      })
      .then(() => {
        this.$store.dispatch("loader/hide");
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/variables.scss";
.collapse-all {
  background-color: $pantoneBlue !important;

  &:focus {
    color: white !important;
  }
  &:active {
    color: $orange !important;
  }
}
</style>
